export function timeFix() {
  const time = new Date();
  const hour = time.getHours();
  // eslint-disable-next-line no-nested-ternary
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了'];
  const index = Math.floor(Math.random() * arr.length);
  return arr[index];
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents');
  event.initEvent('resize', true, true);
  event.eventType = 'message';
  window.dispatchEvent(event);
}

export function handleScrollHeader(callback) {
  let timer = 0;

  let beforeScrollTop = window.pageYOffset;
  // eslint-disable-next-line no-param-reassign
  callback = callback || function () {};
  window.addEventListener(
    'scroll',
    () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        let direction = 'up';
        const afterScrollTop = window.pageYOffset;
        const delta = afterScrollTop - beforeScrollTop;
        if (delta === 0) {
          return false;
        }
        direction = delta > 0 ? 'down' : 'up';
        callback(direction);
        beforeScrollTop = afterScrollTop;
      }, 50);
    },
    false,
  );
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return;
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id));
  }, timeout);
}

let uuidTime = Date.now();
export function uuid() {
  // eslint-disable-next-line no-plusplus
  uuidTime++;
  return `uuid_${uuidTime}`;
}

export function fileSizeValid(rule, value, callback) {
  if (!value[0]) {
    const message = '请上传文件';
    callback(message);
  } else if (value[0].size / 1024 / 1024 > 100) {
    const message = '文件上传大小不得大于100M';
    callback(message);
  } else {
    callback();
  }
}

/**
 * 判断是数组还是对象
 * @param {*} value 要判断的数据
 */
export function isArrayFn(value) {
  if (typeof Array.isArray === 'function') {
    return Array.isArray(value);
  }
  return Object.prototype.toString.call(value) === '[object Array]';
}

/**
 * 根据关键字排序
 * @param {array} ary  要排序的数组
 * @param {string} key  关键字名
 */
export function sortBykey(ary, key) {
  return ary.sort((a, b) => {
    const x = a[key];
    const y = b[key];
    // eslint-disable-next-line no-nested-ternary
    return ((x < y) ? -1 : (x > y) ? 1 : 0);
  });
}

/**
 *
 * @param {*} $this
 * @param {*} list
 */
export function batchDownloadFiles($this, list) {
  // eslint-disable-next-line no-undef
  request.post({
    url: 'api/system/download',
    params: list,
    type: 'json',
  }).then((res) => {
    const { msg } = res.data;
    if (!res.data || res.data.status) {
      if (msg) {
        $this.$message({
          message: msg,
          type: 'error',
        });
      }
      return;
    }
    const sucDownload = [];
    const failDownload = [];
    res.data.forEach((fp) => {
      if (fp.code) {
        sucDownload.push(fp);
      } else {
        failDownload.push(fp);
      }
    });
    failDownload.forEach((fail) => {
      $this.$message({
        message: `${fail.search}下载失败:${fail.msg}`,
        type: 'error',
      });
    });
    sucDownload.forEach(async (data) => {
      const downloadUrl = `${data.url}&${data.token_key}=${data.token_value}`;
      // pom.setAttribute('href', downloadUrl);
      // pom.setAttribute('download', 'test' + Math.random(0, 1));
      // pom.style.display = 'none';
      // document.body.appendChild(pom);
      // pom.click();
      // document.body.removeChild(pom);
      // eslint-disable-next-line no-undef
      await downloadFile(downloadUrl, data.search);
    });
  });
}

/**
 * 把data属性合并入Series中的data
 * @param data
 * @param Series
 */
export function computedSeries(data, series) {
  return series.map(item => ({
    ...item,
    data: data[item.nameEn],
  }));
}

/**
 * 增加千位符
 * @param num
 */
export function formatThousand(num) {
  if (!num && Number(num) !== 0) {
    return '-';
  }
  return num === null ? '' : num.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,');
}
